export default "__VITE_ASSET__BRHmRaXr__"